import { render, staticRenderFns } from "./Arguments.vue?vue&type=template&id=807fc4d0&scoped=true"
import script from "./Arguments.vue?vue&type=script&lang=js"
export * from "./Arguments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807fc4d0",
  null
  
)

export default component.exports